export enum AlertLevel {
  HIGH = 'High',
  MEDIUM = 'Medium',
  LOW = 'Low'
}
